import { isLeftRailVisible } from 'owa-left-rail';
import { LEFT_RAIL_STATIC_WIDTH } from '../internalConstants';

export default function getLeftRailWidth() {
    return isLeftRailVisible() ? LEFT_RAIL_STATIC_WIDTH : 0;
}
